<button #actionButon
  class="btn flex-row items-center btn-shadow"
  [ngClass]="buttonClass"
  [ngStyle]="getBackgroundStyle()"
  (click)="onChange()"
  [disabled]="disabled || loading"
>
  @if(loading){
    <div class="spinner-circle"></div>
  } @else {
    <span
      class="text cursor-pointer close-btn"
      [ngClass]="textClass"
      [ngStyle]="getCloseBtnBackgroundStyle()"
      aria-hidden="true"
    >
      <mat-icon *ngIf="internalActive" class="chip-icon-svg" svgIcon="close"></mat-icon>
      <mat-icon *ngIf="!internalActive" class="chip-icon-svg" svgIcon="plus"></mat-icon>
    </span>
  }
    <span
      class="text flex-1"
      [ngClass]="textClass"
      [ngStyle]="getTextColorStyle()">
      {{ text }}
    </span>

</button>
